<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">

      <h1>
        <p class="text-center font-weight-bold">Alterar nome </p>
        <!-- {{recepcionista}} -->
      </h1>

      <v-form v-model="valid" ref="form" class="mx-4">

        <v-text-field v-model="novoNome" :rules="nomeRules" :type="'text'" name="input-10-1" label="Novo nome" counter @click:append="show1 = !show1"></v-text-field>

        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para alterar!']" required></v-checkbox>
        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Erro ao editar nome !!
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso ao editar nome !!
        </v-alert>
      </v-form>
      <v-card-actions>
        <v-spacer />
         <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
        <v-btn text @click="$router.go(-1)">
        <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'

export default {
  name: 'editarNomeAdministador',
  data() {
    return {
      senhaAtual: '',
      erroEditar: false,
      tipo: 1,
      sucessoEditar: false,
      erroAlterarNome: 'false',
      novoNome: '',
      show1: false,
      show2: false,
      valid: false,
      name: 'Default',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
      ],
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 5 caracteres',
        (v) => v && v.length < 20 || 'nome deve ter menos de 20 caracteres'
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        console.log('for editar adm..')
        console.log(this.user)

        administradorService.administrador
          .alterarNomeAdministrador(this.novoNome, this.user.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data == true) {
              this.$store
                .dispatch("SetUserName", this.novoNome)
              this.sucessoEditar = true
              this.clear()
            }

          })
          .catch(err => {
            this.erroEditar = true
            // handle your error here
            console.log(err)
          })
      }
    },
    clear() {
      this.$refs.form.reset()
    }
  },

  mounted() {
    this.user = this.$store.getters.usuario
    this.novoNome = this.$store.getters.usuario.nome
  }

}
</script>
